
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Toast } from 'vant';
import PopupShell from './PopupShell.vue';
import ConfirmButton from './ConfirmButton.vue';
import header from '../assets/popup-header-address.png';

/** 填写收货地址弹窗 */
@Component({
  components: { PopupShell, ConfirmButton },
})
export default class AddressPopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: String, default: '' }) readonly title!: string;
  // 已填写的收货人姓名 / 收货地址，用于打开弹窗时回填
  @Prop({ type: String, default: '' }) readonly defaultName!: string;
  @Prop({ type: String, default: '' }) readonly defaultAddress!: string;

  header = header;
  address = '';
  name = '';

  @Watch('value')
  onVisible(visible: boolean) {
    if (visible) {
      this.address = this.defaultAddress;
      this.name = this.defaultName;
    }
  }

  // 详情异步返回后再回填（先打开弹窗、后拿到数据的场景）
  @Watch('defaultName')
  onDefaultName(val: string) {
    this.name = val;
  }

  @Watch('defaultAddress')
  onDefaultAddress(val: string) {
    this.address = val;
  }

  onConfirm() {
    if (!this.name) {
      Toast('请填写收货人姓名');
      return;
    }
    if (!this.address) {
      Toast('请填写您的收货地址');
      return;
    }
    this.$emit('confirm', { name: this.name, address: this.address });
  }
}
